var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-img"},[_c('el-image',{staticClass:"img",attrs:{"src":_vm.img || '~@/assets/img/bitmap.png',"fit":"cover"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }